<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left color-theme="white" back-link="返回" back-link-url="#">
      </f7-nav-left>
      <f7-nav-title>{{ this.$f7route.query.title }}</f7-nav-title>
    </f7-navbar>
    <f7-block strong v-if="msgList.length === 0">
      <p style="text-align: center;">暂无消息</p>
    </f7-block>
    <div v-for="item in msgList" :key="item.id" class="item-msg">
      <div class="item-msg-title">
        <div class="msg-title">
          {{ item.type }}
        </div>
        <div class="msg-date">
          <p>{{ item.createTime | formatDateValue }}</p>
        </div>
      </div>
      <div class="item-msg-content">
        <p>{{ item.content }}</p>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { dateFormat } from '@/util/dateUtils';
import { getProjectMsgList } from '@/api/project/project';

export default {
  props: ['projectId'],
  data() {
    return {
      msgList: [],
    };
  },
  mounted() {
    this.getList();
  },

  filters: {
    formatDateValue: value => dateFormat(value, 'YYYY-MM-DD HH:mm'),
  },

  methods: {
    getList() {
      const params = { projectId: this.projectId };
      getProjectMsgList(params).then((result) => {
        if (result.code === 0) {
          this.msgList = result.data || [];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

  @import '~@/style/app-var.scss';

  .item-msg {
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 0.5rem;
    background-color: $white-color;
  }

  .item-msg-title {
    display: flex;
    align-items: center;
  }

  .msg-title {
    flex: auto;
    font-size: 1rem;
    font-weight: bold;
  }

  .msg-date {
    font-size: 1rem;
    color: $second-font-color;
  }

  .item-msg-content {
    color: $black-color;
    font-size: 1rem;
    line-height: 1.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/project/msgList.vue